import type { z } from "zod";

import { zOutSchema, zRes401 } from "./common";

import { Response } from "~/shared/api";

const zRes200 = Response.Schema.zSuccessful(200, zOutSchema);

const zRes = Response.Schema.zAggregated([zRes200, zRes401]);
type Res = z.infer<typeof zRes>;

export { zRes };
export type { Res };
